<div class="modern-admin-page">
  <!-- Page Header -->
  <div class="page-header-card">
    <div class="header-content">
      <div class="page-title-section">
        <h1 class="page-title bangla-heading">একাধিক এ্যাসেসমেন্ট আবেদন</h1>
        <p class="page-subtitle">এক্সেল ফাইল ব্যবহার করে একসাথে একাধিক এ্যাসেসমেন্ট তৈরি করুন</p>
      </div>
      <div class="page-actions">
        <button type="button" routerLink="/admin/assessment-create" class="btn-secondary-modern">
          <i class="fas fa-plus"></i>
          নতুন এ্যাসেসমেন্ট
        </button>
        <button type="button" routerLink="/admin/assessment-page" class="btn-outline-modern">
          <i class="fas fa-list"></i>
          এ্যাসেসমেন্ট তালিকা
        </button>
      </div>
    </div>
  </div>

  <!-- Main Content -->
  <div class="content-grid">
    
    <!-- File Upload Section -->
    <div class="content-card slide-up">
      <div class="card-header">
        <h3 class="card-title bangla-title">
          <i class="fas fa-upload"></i>
          এক্সেল ফাইল আপলোড
        </h3>
      </div>
      
      <div class="card-body">
        <div class="upload-section">
          <div class="upload-form">
            <div class="form-group">
              <label class="form-label bangla-label">এক্সেল ফাইল নির্বাচন করুন</label>
              <input 
                (change)="ReadExcel($event)" 
                type="file" 
                name="holdingNo" 
                class="form-control" 
                id="excelFile" 
                accept=".xlsx,.xls"
                placeholder="এক্সেল ফাইল নির্বাচন করুন">
            </div>
            
            <div class="button-group">
              <button 
                (click)="uploadToDatabase()" 
                type="button" 
                class="btn-primary-modern"
                [disabled]="!ExcelData || ExcelData.length === 0">
                <i class="fas fa-database"></i>
                ডাটাবেসে আপলোড
              </button>
              
              <button 
                (click)="exportTableToExcel()" 
                type="button" 
                class="btn-outline-modern">
                <i class="fas fa-download"></i>
                নমুনা ফাইল ডাউনলোড
              </button>
            </div>
          </div>
          
          <!-- Upload Instructions -->
          <div class="upload-instructions">
            <h4 class="bangla-label">
              <i class="fas fa-info-circle"></i>
              নির্দেশাবলী
            </h4>
            <ul class="instruction-list">
              <li>প্রথমে "নমুনা ফাইল ডাউনলোড" বাটন ক্লিক করে নমুনা এক্সেল ফাইল ডাউনলোড করুন</li>
              <li>নমুনা ফাইলের ফরম্যাট অনুযায়ী তথ্য পূরণ করুন</li>
              <li>সম্পূর্ণ তথ্য পূরণের পর ফাইলটি আপলোড করুন</li>
              <li>ডেটা যাচাই করার পর "ডাটাবেসে আপলোড" বাটন ক্লিক করুন</li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <!-- Data Preview Section -->
    <div class="content-card slide-up" *ngIf="ExcelData && ExcelData.length > 0">
      <div class="card-header">
        <h3 class="card-title bangla-title">
          <i class="fas fa-table"></i>
          ডেটা প্রিভিউ
        </h3>
        <div class="card-actions">
          <span class="data-count">
            মোট <strong>{{ExcelData.length}}</strong> টি রেকর্ড
          </span>
        </div>
      </div>
      
      <div class="card-body">
        <div class="table-responsive">
          <table class="table-modern">
            <thead>
              <tr>
                <th class="bangla-label">হোল্ডিং নং</th>
                <th class="bangla-label">নাম</th>
                <th class="bangla-label">পিতা/স্বামীর নাম</th>
                <th class="bangla-label">ওয়ার্ড নং</th>
                <th class="bangla-label">ভাতা</th>
                <th class="bangla-label">পেশা</th>
                <th class="bangla-label">ঠিকানা</th>
                <th class="bangla-label">মোবাইল</th>
                <th class="bangla-label">খানার ধরণ</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let data of ExcelData; let i = index" [class.table-striped]="i % 2 === 0">
                <td class="bangla-text">{{data.holding_number}}</td>
                <td class="bangla-text">{{data.name}}</td>
                <td class="bangla-text">{{data.gurdian_name}}</td>
                <td class="bangla-text">{{data.ward_number}}</td>
                <td class="bangla-text">{{data.vata}}</td>
                <td class="bangla-text">{{data.pesha}}</td>
                <td class="bangla-text">{{data.gram_or_rasta}}</td>
                <td class="bangla-text">{{data.mobile_number}}</td>
                <td class="bangla-text">{{data.khanar_dhoron}}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <!-- Empty State -->
    <div class="content-card slide-up" *ngIf="!ExcelData || ExcelData.length === 0">
      <div class="card-body">
        <div class="empty-state">
          <div class="empty-icon">
            <i class="fas fa-file-excel"></i>
          </div>
          <h3 class="bangla-title">কোন ডেটা পাওয়া যায়নি</h3>
          <p class="bangla-text">এক্সেল ফাইল আপলোড করুন অথবা নমুনা ফাইল ডাউনলোড করে শুরু করুন</p>
        </div>
      </div>
    </div>

  </div>
</div>

<!-- Hidden Template Table for Export -->
<table hidden id="tableId" class="table">
  <thead>
    <tr>
      <th>ward_number</th>
      <th>ward_name</th>
      <th>holding_number</th>
      <th>name</th>
      <th>gurdian_name</th>
      <th>mobile_number</th>
      <th>id_number</th>
      <th>vata</th>
      <th>pesha</th>
      <th>khanar_dhoron</th>
      <th>khanar_anumanik_mullo</th>
      <th>khanar_dharjokrito_kor</th>
      <th>gram_or_rasta</th>
      <th>post_office</th>
      <th>upozilla</th>
      <th>zilla</th>
    </tr>
  </thead>
</table>